import React from 'react'
import { MainBlock } from '@blocks/BlockMain/model'
import { scrollToPartnerForm } from '@shared/components/forms/partner'
import { ProductListLoan } from '@shared/components/sections/product-loans/ItemDescription'
import CheckCircle from '@shared/svg/check-circle.svg'
import Clock from '@shared/svg/clock.svg'
import Desktop from '@shared/svg/desktop.svg'
import Case from '@shared/svg/icon-case.svg'
import IconPeople from '@shared/svg/icon-people.svg'
import MapPin from '@shared/svg/map-pin.svg'
import Note from '@shared/svg/note.svg'
import UserFocus from '@shared/svg/user-focus.svg'
import { ComfortFormatBlock } from 'screens/estate-agents/sections/comfort-format/view'

export const mainBlock: MainBlock = {
	title: <>Ипотечный сервис для риелторов и кредитных брокеров</>,
	textItems: [
		<>Автоматическая подготовка заявки в&nbsp;банк&#8288;-&#8288;партнёр</>,
		'Скоринг заёмщиков и оценка недвижимости',
		'Доставка ипотеки по России',
	],
	faceImageName: {
		default: 'KV-loans-business.png',
		desktop: 'KV-loans-business.png',
	},
	buttonText: 'Узнать о сервисе',
	imageAlt: 'Брокер',
}

export const comfortBlocks: ComfortFormatBlock[] = [
	{
		id: 1,
		title: <>Ассоциация финансовой грамотности «Процент»</>,
		Icon: IconPeople,
		text: (
			<>
				Это некоммерческая организация, которая занимается развитием финансовой грамотности в
				России. Совместно с сервисом Credit.Club Ипотека она помогает заёмщикам решать вопросы в
				сфере кредитования и инвестиций, а также делится информацией для защиты от финансовых
				рисков.
			</>
		),
		btnText: 'Стать партнёром',
		onClick: scrollToPartnerForm,
	},
	{
		id: 2,
		title: <>Площадка для экспертов</>,
		Icon: Case,
		text: (
			<>
				При подключении сервиса каждый аккредитованный партнёр получает бесплатную возможность стать
				экспертом на площадке, а также помощь в подготовке статей и видео для развития имиджа своей
				компании и рынка финансовых услуг в России.
			</>
		),
	},
]

export const productListLoan: ProductListLoan[] = [
	{
		id: 1,
		title: <>Доступны ставки на&nbsp;уровне банков</>,
		description: [
			'Без страховок',
			'Лояльны к кредитной истории',
			'Без скрытых платежей и комиссий',
		],
	},
	{
		id: 2,
		title: <>Срок&nbsp;— до&nbsp;20 лет</>,
		description: ['Для физических и юридических лиц', 'Решение за 1–2 рабочих дней'],
	},
	{
		id: 3,
		title: <>От 200 тысяч до&nbsp;15&nbsp;млн&nbsp;₽</>,
		description: ['Минимальный пакет документов', 'Не требуем справки о доходах'],
	},
]

export const serviceProsList = [
	{
		id: 1,
		text: 'Автоматическое заполнение заявки с загрузкой данных из Госуслуг',
		Icon: Clock,
	},
	{
		id: 2,
		text: 'Скоринг заёмщика и оценка объекта недвижимости',
		Icon: UserFocus,
	},
	{
		id: 3,
		text: 'Подготовка документов для сделки',
		Icon: Note,
	},
	{
		id: 4,
		text: 'Юридически подтвержденное онлайн-подписание документов',
		Icon: CheckCircle,
	},
	{
		id: 5,
		text: 'Доставка ипотеки по России',
		Icon: MapPin,
	},
	{
		id: 6,
		text: 'Онлайн-регистрация сделки в Росреестре',
		Icon: Desktop,
	},
]
